import React from 'react'
import { connect } from 'react-redux'

import PageWrapper from '../../components/PageWrapper'
import WhiteBox from '../../components/WhiteBox'

import RevenueBuyers from '../../components/RevenueBuyersList'
import { RangeSelectorBuyers } from './range-selector-buyers'
import { Preloader } from '../../components/Chart/index'

import moment from 'moment'
import debounce from 'lodash/debounce'
import './style.css'
import axios from 'axios'
import { dayStart, dayEnd, earlierDate } from '../../lib/format-date'
import { CSVDownload } from 'react-csv'
import ReactTooltip from 'react-tooltip'

import Alert from 'react-s-alert'
import 'react-s-alert/dist/s-alert-default.css'
import DMPFilter from '../../components/DMPFilter'

import { Bootstrap2Toggle } from 'react-bootstrap-toggle'



class Revenue extends React.Component {
    state = {
        range: null,
        maxDate: null,
        size: 10,
        offset: 0,
        filter: '',
        sort: 'impressions',
        sortOrder: 'desc',
        dmp: '',
        dmpProduct: '',
        revenues: [],
        lastUpdated: null,
        csvData: null,
        reportType: 'summary',
        groupByBuyers: true,

    }


    componentDidMount() {
        this.debouncedSearchSummary = debounce(this.fetchRevenuesSummary, 300)


        axios.get('/revenue/buyers/last_updated').then(response => {
            let lastUpdated = response.data.body
            console.log("last updated ", lastUpdated)
            let d = new Date(lastUpdated)
            let year = d.getFullYear()
            let month = d.getMonth()

            let startDate = moment([year, month]).startOf('month')
            let endDate = moment([year, month]).endOf('month')
            console.log("startDate", startDate)
            console.log("endDate", endDate)

            this.setState({
                maxDate: endDate,
                range: {
                    type: 'custom',
                    startDate: startDate,
                    endDate: endDate
                },
            }, () => {



                // set the current date filter 
                this.loadRevenues(true)


            })


        })



    }


    loadRevenues(reset = false) {
        this.debouncedSearchSummary(
            this.state.filter,
            this.state.size,
            this.state.offset,
            this.state.sort,
            this.state.sortOrder,
            this.state.range,
            this.state.dmp,
            this.state.dmpProduct,
            this.state.groupByBuyers,
            reset,
        )
    }

    onFilterChange(target) {
        console.log('onFilterChange', target.value, this)
        this.setState({ revenues: [], offset: 0, filter: target.value }, () => {
            this.loadRevenues(true)
        })
    }
    onSortChange(sortField) {
        /*let sort = this.state.sort
        let sortOrder = this.state.sortOrder
        if (sort != sortField) {
            sortOrder = 'asc'
        } else {
            // toggle if is the same field
            sortOrder = sortOrder == 'asc' ? 'desc' : 'asc'
        }
        sort = sortField
        this.setState({ sort: sort, sortOrder: sortOrder, offset: 0 }, () => {
            this.loadRevenues()
        })*/
    }
    // used only in details pagination
    onLoadMoreDetails() {
        let offset = this.state.offset + this.state.size
        this.setState({ offset: offset }, () => {
            //
            this.loadRevenues(false)
        })
    }


    fetchRevenuesSummary(filter, size, offset, sort, sortOrder, range, dmp, dmpProduct, groupByBuyers, reset = false) {
        const { start, end } = this.findStartEnd(range)

        let revenues = this.state.revenues
        if (reset) {
            revenues = []
        }

        this.setState(
            {
                revenues: revenues,
                loading: true
            },
            () => {
                axios
                    .get(
                        `/revenue/buyers?groupBy=${groupByBuyers}&marketplace=${dmp}&offset=${offset}&size=${size}&filter=${filter}&sort=${sort}&sortOrder=${sortOrder}&start=${start}&end=${end}`
                    )
                    .then(response => {
                        console.log('revenues', response, response.data.body)
                        let newEvents = response.data.body.revenues

                        console.log('events', newEvents)
                        let oldEvents = this.state.revenues
                        oldEvents = oldEvents.concat(newEvents)

                        this.setState({
                            revenues: oldEvents,
                            lastUpdated: response.data.body.lastUpdated,
                            loading: false
                        })
                    })
            }
        )
    }

    onCSVExport() {
        const { start, end } = this.findStartEnd(this.state.range)

        this.setState({ loading: true }, () => {
            let url = `/revenue/buyers/export?groupBy=${this.state.groupByBuyers}&dmp=${this.state.dmp}&offset=0&size=1000&filter=${this.state.filter}&sort=${this.state.sort}&sortOrder=${this.state.sortOrder}&start=${start}&end=${end}`

            axios.get(url).then(response => {
                console.log('revenues', response, response.data.body)

                Alert.success('Export queued successfully. Please check the Events page after some time to get the donwload link of the report!')


                this.setState({
                    loading: false
                })

            })
        })
    }

    getDownloadLink(fileBucket, fileKey) {
        this.setState({ loading: true }, () => {
            axios.get('/events/downloadurl?s3Bucket=' + fileBucket + '&s3Prefix=' + fileKey).then(response => {
                console.log('downloadurl response', response)
                window.open(response.data.body, '_blank')

            }).finally(() => {
                this.setState({ loading: false })
            })
        })
    }



    findStartEnd(range) {
        let start, end

        console.log('findStartEnd', range)
        switch (range.type) {
            case 'custom':
                start = dayStart(range.startDate).format('YYYY-MM-DD')
                end = earlierDate(dayEnd(range.endDate), moment()).format('YYYY-MM-DD')
                break
            case 'last':
                const month = moment().month()
                start = dayStart(
                    moment()
                        .month(month - 1)
                        .date(1)
                ).format('YYYY-MM-DD')
                end = dayEnd(moment().date(0)).format('YYYY-MM-DD')
                break
            case 'current':
            default:
                start = dayStart(moment().date(1)).format('YYYY-MM-DD')
                end = moment().format('YYYY-MM-DD')
                break
        }

        return { start, end }
    }

    handleRangeChange(newRange) {
        console.log('handleRangeChange newRange', newRange)
        const oldRange = this.state.range

        if (newRange.type !== 'custom' && newRange.type === oldRange.type) return
        else if (newRange.type === 'custom' && newRange.startDate === oldRange.startDate && newRange.endDate === oldRange.endDate) return

        this.setState({ revenues: [], offset: 0, range: newRange }, () => {
            this.fetchRevenuesSummary(
                this.state.filter,
                this.state.size,
                this.state.offset,
                this.state.sort,
                this.state.sortOrder,
                newRange,
                this.state.dmp,
                this.state.dmpProduct,
                this.state.groupByBuyers,
                true,
            )

        })
    }

    onDmpChange(dmp) {
        this.setState({ revenues: [], offset: 0, dmp: dmp, dmpProduct: '' }, () => {
            this.loadRevenues(true)
        })

    }

    render() {
        const { range } = this.state
        return (
            <PageWrapper>
                <div className="container-fluid">
                    {this.state.loading && <Preloader transparent />}


                    <div className="row">
                        <div className="col-lg-12">
                            <WhiteBox customStyle={{ overflow: 'visible' }}>

                                <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 40 }}>
                                    <h3 className="box-title">Marketplace Buyers Report</h3>

                                    <div style={{ flex: 1 }} />
                                </div>


                                <div className="row">
                                    <div className="col-2" style={{
                                        position: 'relative',
                                        top: '-30px',
                                    }}>
                                        {this.state.range && (
                                            <span>


                                                <RangeSelectorBuyers
                                                    range={range}
                                                    maxDate={this.state.maxDate}
                                                    onChangeRange={range => this.handleRangeChange(range)} />
                                            </span>
                                        )}
                                    </div>
                                    <div className="col-3" style={{ 'top': '-60px' }}>
                                        <DMPFilter
                                            showAllProductOption="true"
                                            showProducts="false"
                                            hideArDmp="true"
                                            onDmpChange={this.onDmpChange.bind(this)}

                                        />
                                    </div>

                                    <div className="col-3" style={{ 'top': '-60px' }}>

                                        <p style={{ whiteSpace: 'nowrap', marginTop: 30 }}>Group by Buyer</p>
                                        <Bootstrap2Toggle
                                            id="active"
                                            onClick={value => {
                                                let groupByBuyers = this.state.groupByBuyers
                                                this.setState({ groupByBuyers: !groupByBuyers }, () => {

                                                    this.loadRevenues(true)


                                                })



                                            }}
                                            on={<span>YES</span>}
                                            off={<span>NO</span>}
                                            size="xs"
                                            offstyle="secondary"
                                            active={this.state.groupByBuyers}
                                        />

                                    </div>

                                </div>







                                <div
                                    className="text-right"
                                    style={{
                                        position: 'relative',
                                        top: '-110px',
                                        width: '50%',
                                        right: '0%',
                                        left: '50%'
                                    }}>
                                    {this.state.lastUpdated && (
                                        <span style={{ fontSize: 'smaller', color: 'grey' }}>
                                            Last Updated:{' '}
                                            {moment(this.state.lastUpdated, 'YYYY-MM-DD')
                                                .toDate()
                                                .toLocaleDateString()}
                                        </span>
                                    )}
                                    &#160;&#160;
                                    <ReactTooltip id="exportCSVRevenuesBtnTooltip" type="dark" effect="solid">
                                        <span>Export as Excel XLS File</span>
                                    </ReactTooltip>

                                    <button
                                        className="border-button inlinebuttons "
                                        data-tip
                                        data-for="exportCSVRevenuesBtnTooltip"
                                        href="#"
                                        onClick={() => this.onCSVExport()}>
                                        <i className="fa fa-file-excel-o fa-3" style={{ fontSize: '20px', top: '2px', position: 'relative' }}></i>&#160; Export
                                    </button>
                                    {/* render only if we have csv data */}
                                    {this.state.csvData != null && <CSVDownload filename={'revenue-export.csv'} data={this.state.csvData} />}
                                </div>


                                <div className="row" style={{ 'top': '-80px', 'position': 'relative' }}>
                                    <div className="col-lg-12">

                                        <RevenueBuyers
                                            loading={this.props.loading}
                                            onLoadMore={this.onLoadMoreDetails.bind(this)}
                                            offset={this.state.offset}
                                            size={this.state.size}
                                            revenues={this.state.revenues}
                                            sort={this.state.sort}
                                            sortOrder={this.state.sortOrder}
                                            onSortChange={this.onSortChange.bind(this)}
                                            groupBy={this.state.groupByBuyers}
                                        />

                                    </div>
                                </div>



                            </WhiteBox>
                        </div>
                    </div>
                </div>
            </PageWrapper>
        )
    }
}

export default connect()(Revenue)
